import CachedIcon from '@mui/icons-material/Cached';
import { Box, Grid, Stack } from '@mui/material';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { IJob, amplitude } from 'wisestep-api';
import {
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
  WsButton,
  ChipsType,
  WsTagsList,
} from 'wisestep-base';

import { useWorkspaceContext } from '../../../../../src/context';

interface JDGeneratorDialogProps {
  jobDescriptionData: IJob;
  onJDGeneration: (jobDescriptionData) => void;
  onRegenerate: () => void;
}

const JDGeneratorDetailsDialog = ({
  jobDescriptionData,
  onJDGeneration,
  onRegenerate,
}: JDGeneratorDialogProps) => {
  const workspace = useWorkspaceContext();
  const booleanAmplitudeEvents = (name: string, clickedOnName: string) =>
    amplitude(name, {
      clickedOn: clickedOnName,
      workspaceName: workspace.name,
      pageName: 'New Job',
      planType: workspace.planType,
      interfaceType: 'web',
      pageUrl: window.location.href,
    });
  return (
    <Grid justifyContent="flex-start" container spacing={1} direction="column" p={2}>
      <Grid item xs={12} container direction="row">
        <WsTypography
          variant={WsTypoVariants.SUB_TITLE}
          color={WsTypoColors.PRIMARY}
          cursor="pointer"
          bold
        >
          Job Title :
        </WsTypography>
        <WsTypography cursor="pointer" variant={WsTypoVariants.SUB_TITLE}>
          &nbsp;{`${jobDescriptionData.title}`}
        </WsTypography>
      </Grid>
      <Grid item xs={12}>
        <WsTypography
          variant={WsTypoVariants.SUB_TITLE}
          color={WsTypoColors.PRIMARY}
          cursor="pointer"
          bold
        >
          Location :
        </WsTypography>
        <Box py={1} px={2}>
          <WsTagsList
            chipArray={
              jobDescriptionData?.locations?.map((location) =>
                [location.city, location.state, location.country].filter(Boolean).join(',')
              ) ?? []
            }
            count={3}
            type={ChipsType.SECONDARY}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <WsTypography
          variant={WsTypoVariants.SUB_TITLE}
          color={WsTypoColors.PRIMARY}
          cursor="pointer"
          bold
        >
          Job Description
        </WsTypography>
        <Box style={{ overflowY: 'auto' }} p={1.5}>
          <div dangerouslySetInnerHTML={{ __html: jobDescriptionData.description ?? '' }}></div>
        </Box>
      </Grid>
      <Grid container direction="row" item xs={12} p={0.5}>
        <WsTypography
          variant={WsTypoVariants.SUB_TITLE}
          color={WsTypoColors.PRIMARY}
          cursor="pointer"
          bold
        >
          Skills :
        </WsTypography>
      </Grid>
      <Box py={1} px={2}>
        <WsTagsList
          chipArray={jobDescriptionData.skills ?? []}
          count={5}
          type={ChipsType.PRIMARY}
        />
      </Box>
      {jobDescriptionData.jobType && (
        <Grid container direction="row" item xs={12} p={0.5}>
          <WsTypography
            variant={WsTypoVariants.SUB_TITLE}
            color={WsTypoColors.PRIMARY}
            cursor="pointer"
            bold
          >
            Job Type :
          </WsTypography>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} cursor="pointer">
            &nbsp;&nbsp;{`${jobDescriptionData.jobType}`}
          </WsTypography>
        </Grid>
      )}
      {jobDescriptionData.industry && (
        <Grid container direction="row" item xs={12} p={0.5}>
          <WsTypography
            variant={WsTypoVariants.SUB_TITLE}
            color={WsTypoColors.PRIMARY}
            cursor="pointer"
            bold
          >
            Industry :
          </WsTypography>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} cursor="pointer">
            &nbsp;&nbsp;{`${jobDescriptionData.industry}`}
          </WsTypography>
        </Grid>
      )}
      <Grid item xs={12} p={2} container justifyContent="flex-end" spacing={2}>
        <Stack direction="row" spacing={2}>
          <WsButton
            variant="outlined"
            startIcon={<CachedIcon style={{ color: WsTypoColors.PRIMARY }} />}
            onClick={() => {
              booleanAmplitudeEvents('Generate_JD_Regenerate', 'Generate_JD_Regenerate_Button');
              onRegenerate;
            }}
          >
            Regenerate
          </WsButton>
          <WsButton
            variant="contained"
            endIcon={<MdKeyboardArrowRight />}
            onClick={() => {
              booleanAmplitudeEvents('Generate_JD_Complete', 'Generate_JD_Complete_Button');
              onJDGeneration(jobDescriptionData);
            }}
          >
            Continue
          </WsButton>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default JDGeneratorDetailsDialog;
